var _defs, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrSouparceiroAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-dot-color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,5.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,5.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,5.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,5.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,5.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,5.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,14.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,14.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,14.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,14.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,14.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,14.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,50.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,50.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,50.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,50.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,50.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,50.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,50.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,59.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,59.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,59.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,59.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,59.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,59.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,59.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,59.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,59.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,68.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,68.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,68.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,68.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,68.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,68.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,68.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 10,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,14.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 55,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 19,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,23.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 28,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 46,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,50.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 64,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,68.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 28,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 55,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 280,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,284.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 1,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,5.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 19,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,23.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 28,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 280,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,284.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 28,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 55,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 64,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,68.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 280,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,284.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 1,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,5.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 19,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,23.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 46,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,50.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 1,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,5.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 10,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,14.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 28,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 46,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,50.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 55,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 280,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,284.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 28,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 64,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,68.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 19,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,23.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 55,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 64,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,68.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 280,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,284.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 1,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,5.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 10,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,14.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 19,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,23.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 46,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,50.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 280,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,284.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 1,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,5.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 55,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 280,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,284.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 10,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,14.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 19,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,23.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 280,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,284.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 10,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,14.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 55,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 64,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,68.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 289,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,293.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 1,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,5.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 19,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,23.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 46,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,50.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 280,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,284.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 19,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,23.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 46,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,50.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 55,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 64,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,68.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 280,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,284.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 19,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,23.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 280,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,284.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 289,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,293.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 1,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,5.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 10,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,14.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 55,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 280,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,284.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 289,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,293.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 280,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,284.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 280,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,284.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 280,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,284.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 289,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,293.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 280,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,284.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 289,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,293.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 280,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,284.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,284.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,284.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,284.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,284.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,284.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,284.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,284.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,284.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,293.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,293.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,293.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,293.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,293.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,293.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,293.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,293.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,293.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,293.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 289,
    width: 9,
    height: 9,
    transform: "rotate(0,293.5,293.5)"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 1 1v 63h 63v -63zM 10 10h 45v 45h -45z",
    transform: "rotate(0,32.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,23.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 28,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 19,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,23.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 19,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,23.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 28,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,41.5)"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 235 1v 63h 63v -63zM 244 10h 45v 45h -45z",
    transform: "rotate(90,266.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 19,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,23.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 28,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 19,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,23.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 28,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 19,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,23.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 28,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,41.5)"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 1 235v 63h 63v -63zM 10 244h 45v 45h -45z",
    transform: "rotate(-90,32.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,275.5)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 300,
    width: 300,
    clipPath: "url('#clip-path-background-color')",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 300,
    width: 300,
    clipPath: "url('#clip-path-dot-color')",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrSouparceiroAndroid);
export default __webpack_public_path__ + "static/media/qr-souparceiro-android.6a4262576093221826f93db178e30e49.svg";
export { ForwardRef as ReactComponent };